// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"b30c25bc","297":"ba32b0d1","377":"0aa5edf4","643":"e860b552"}[chunkId] + ".chunk.js";
};